<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h2>{{ $t('create.service') }}</h2>
    </div>
    <div class="modal-content">
      <form
        id="form-create-queue"
      >
        <div class="input-group">
          <div class="input input-text">
            <label for="service-id">ID</label>
            <input
              id="service-id"
              v-model="serviceID"
              :placeholder="$t('insert.service.id')"
              type="text"
              required
            >
          </div>
        </div>

        <div class="input-group">
          <div class="input input-text">
            <label for="service-name-pt">{{ $t('name') }} - {{ $t('portuguese') }}</label>
            <input
              id="service-name-pt"
              v-model="namePt"
              :placeholder="$t('insert.service.name.in.portuguese')"
              type="text"
              required
            >
          </div>
        </div>

        <div class="input-group">
          <div class="input input-text">
            <label for="service-name-en">{{ $t('name') }} - {{ $t('english') }}</label>
            <input
              id="service-name-en"
              v-model="nameEn"
              :placeholder="$t('insert.service.name.in.english')"
              type="text"
              required
            >
          </div>
        </div>

        <div class="input-group">
          <div class="input input-text">
            <label for="service-acronym">{{ $t('acronym') }}</label>
            <input
              id="service-acronym"
              v-model="acronym"
              :placeholder="$t('insert.service.acronym')"
              type="text"
              required
            >
          </div>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-active main-action"
            @click="createService()"
          >
            {{ $t('create') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import api from '@/api'

export default {
  name: 'AddService',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      open: false,
      serviceID: null,
      namePt: null,
      nameEn: null,
      acronym: null
    }
  },
  computed: {
    ...mapState([
      'service',
      'currentTickets'
    ])
  },
  methods: {
    async close () {
      this.$emit('input', false)
    },
    ...mapActions([
      'fetchServices',
      'fetchCurrentTickets'
    ]),

    async createService () {
      const service = {
        title: {
          pt: this.namePt,
          en: this.nameEn
        },
        acronym: this.acronym,
        id: this.serviceID,
        online: false,
        printer: false,
        active: false
      }
      await api.addService({ service })
      await this.fetchServices()
      this.close()
    }
  }
}
</script>
